import React from "react";
import { Card,Skeleton } from "antd";
import "../../pages/UI_Recommendations/ProductPage.css";

const ProductSkeleton = ({ loading=true }) => (
  <>
  {loading &&

<Card
              className="product-card"
              style={{ width: "100%", display: "flex", flexDirection: "row",marginTop:"10px" }}
            >
              <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                <Skeleton.Image active style={{ width: 80, height: 80 }} />
                <div style={{ flexGrow: 1, padding: "6px 10px", width: "82%" }}>
                  <Skeleton active paragraph={{ rows: 2 }} title={false} />
                  <Skeleton.Button active style={{ marginTop: 10, width: 120 }} />
                </div>
              </div>
            </Card>


  }
  </>
);

export default ProductSkeleton;